export const TrustStrip = () => (
  <section className="strip">
    <div className="container strip-inner">
      <p>We work in the tools your team already trusts</p>
      <div className="platforms">
        <span>Tableau</span>
        <span>Power BI</span>
        <span>SQL</span>
        <span>Python</span>
        <span>Excel</span>
      </div>
    </div>
  </section>
);
